enum CustomConfigs {
  DisableGTM = 'vdp-disable-gtm',
  DisableLazyLoad = 'vdp-disable-lazy-load',
  DisableSpinner = 'vdp-disable-spinner',
  enableGeicoDiscount = 'enable-geico-discount',
  EnableMfeDebug = 'merch-enable-mfe-debug',
  FeatureBranch = 'feature-branch',
  ForceServerError = 'force-server-error',
  MockVehicle = 'vdp-mock-vehicle',
  PriceDrop = 'show-price-drop-banner',
  RemoveFooter = 'vdp-remove-footer',
  RemoveHeader = 'vdp-remove-header',
  shouldShowWSYS = 'should-show-wsys',
  showShaqvanaVideosSection = 'show-shaqvana-videos-section',
  useCatalogOEMData = 'use-catalog-oem-data',
  useVdpAppRouter = 'use-vdp-app-router',
  useVaultWhyBuy = 'use-vault-why-buy',
  withModalOpen = 'wmo'
}

export default CustomConfigs;
